import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DomUtils, IconButton, TimesIcon } from '@onsolve/onsolve-ui-components';

class CloseButton extends Component {
    constructor(props) {
        super(props);

        this.elementRef = React.createRef();
    }

    componentDidMount() {
        setTimeout(() => {
            DomUtils.setFocus(this.elementRef);
        }, 0);
    }

    render() {
        const { onClose, onKeyDown } = this.props;

        return (
            <IconButton size="xs" onClick={onClose} tabIndex={0} ref={this.elementRef} onKeyDown={onKeyDown}>
                <TimesIcon color="secondary" size="md" />
            </IconButton>
        );
    }
}

CloseButton.propTypes = {
    onClose: PropTypes.func,
    onKeyDown: PropTypes.func
};

export default CloseButton;
